import { put, all, call, takeLatest } from 'redux-saga/effects'

import { messagesModule, interviewRequestsModule } from '../modules'
import { fetchInterviewRequestDetail } from '../apiModules/interviewRequests'
import { createMessage, fetchMessages } from '../apiModules/messages'

function* fetchMessagesSaga({ payload }) {
  yield put(messagesModule.fetchLoading(true))
  const response = yield fetchMessages(payload.id, { page: payload.page })
  yield put(messagesModule.fetchSuccess(response))
}

function* fetchIRMessagesSaga({ payload }) {
  yield put(messagesModule.fetchLoading(true))

  const [interviewRequest, messages] = yield all([call(fetchInterviewRequestDetail, payload.id), call(fetchMessages, payload.id)])

  yield put(messagesModule.fetchSuccess(messages))
  yield put(interviewRequestsModule.fetchDetailSuccess(interviewRequest))
}

function* createMessageSaga({ payload }) {
  yield put(messagesModule.creating(true))
  const response = yield createMessage(payload.id, payload.data)
  yield put(messagesModule.createSuccess(response))
}

export default function* watchMessagesSaga() {
  yield takeLatest(messagesModule.FETCH, fetchMessagesSaga)
  yield takeLatest(messagesModule.FETCH_IR, fetchIRMessagesSaga)
  yield takeLatest(messagesModule.CREATE, createMessageSaga)
}
